var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1 gap-y-4"},[_c('tree-data-table',{attrs:{"items":_vm.devices,"headers":_vm.headers}}),_c('home-chart',{attrs:{"selecteddevice":_vm.selecteddevice,"start":_vm.tsRange.start,"end":_vm.tsRange.end}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }